import { render, staticRenderFns } from "./Leiloes.vue?vue&type=template&id=2d89c676&scoped=true"
import script from "./Leiloes.vue?vue&type=script&lang=js"
export * from "./Leiloes.vue?vue&type=script&lang=js"
import style0 from "./Leiloes.vue?vue&type=style&index=0&id=2d89c676&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d89c676",
  null
  
)

export default component.exports